import { render, staticRenderFns } from "./world.vue?vue&type=template&id=133f2d5a&scoped=true&"
import script from "./world.vue?vue&type=script&lang=js&"
export * from "./world.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f2d5a",
  null
  
)

export default component.exports